import { linksConstants } from "../../src/constants/linksConstants";
import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import butter from "../../src/landingPage/utils/butter-client";
import { WebinarRegistration } from "../../src/landingPage/views/WebinarRegistration/WebinarRegistration";

const WebinarRegistrationPage = ({ post, resolvedUrl }) => {
  return (
    <>
      <NextHead
        currentPath={resolvedUrl}
        title={post?.metatitle}
        description={post?.metadescription}
      />
      <WebinarRegistration post={post} />
    </>
  );
};
export default WebinarRegistrationPage;

export const getServerSideProps = async ctx => {
  try {
    const { id } = ctx.params;
    const { resolvedUrl } = ctx;
    const response = await butter.page.retrieve("webinar-registration", id);
    return {
      props: {
        resolvedUrl,
        post: response.data.data.fields,
      },
    };
  } catch (e) {
    return {
      redirect: {
        destination: linksConstants.HOME,
        permanent: false,
      },
    };
  }
};
